// export const happypathmock = {
//     data: {
//         Inquilino: {
//             DocumentNumber: "1016103160",
//             DocumentType: "C"
//         },
//         coverages: [
//             {
//                 vlocity_ins__ProductName__c: "Servicios públicos",
//                 Id: "0QLdq0000003buOGAQ"
//             },
//             {
//                 vlocity_ins__ProductName__c: "Servicio de restitución del inmueble",
//                 Id: "0QLdq0000003buPGAQ"
//             },
//             {
//                 vlocity_ins__ProductName__c: "Pago arrendamiento",
//                 Id: "0QLdq0000003buQGAQ"
//             },
//             {
//                 vlocity_ins__ProductName__c: "Pago Administración",
//                 Id: "0QLdq0000003buRGAQ"
//             },
//             {
//                 vlocity_ins__ProductName__c: "Asistencia domiciliaria",
//                 Id: "0QLdq0000003buSGAQ"
//             }
//         ],
//         ContractStartDate: "17-11-2024",
//         PropertyCity: "Medellin",
//         RealEstateLicensePlate: "EEV-845-796",
//         PropertyAddress: "cll 40 n 23-85",
//         LastName: "CORREA",
//         DocumentNumber: "1016103160",
//         Phone: "3227347011",
//         DocumentType: "C",
//         FirstName: "Diana",
//         TimeDiff: 0,
//         RecordTypeId: "012D5000000BNyvIAG",
//         SURAUrlPago__c: "/pago/suratech/673ccc242500006d2039765a",
//         SURAEstadoProcesoDePago__c: "Paid",
//         OpportunityId: "006dq000001o5rxAAA",
//         vlocity_ins__TotalAmount__c: 1058594,
//         vlocity_ins__EffectiveDate__c: "2024-10-04",
//         CreatedDate: "2024-10-03T21:36:03.000Z",
//         Id: "0Q0dq0000004ly1CAA",
//         leadId: "00Qdq000001hQ9xEAE",
//         quoteId: "0Q0dq0000004ly1CAA",
//         planName: "Arma tu plan"
//     },
//     error: false
// }

export const happypathmock = {
    data: {
        idCotizacion: "512300000011",
        Inquilino: {
            DocumentType: "C",
            DocumentNumber: "46450272"
        },
        coverages: [
            {
                Id: "0QLdq0000006dmmGAA",
                vlocity_ins__ProductName__c: "Servicios públicos"
            },
            {
                Id: "0QLdq0000006dmnGAA",
                vlocity_ins__ProductName__c: "Servicio de restitución del inmueble"
            },
            {
                Id: "0QLdq0000006dmoGAA",
                vlocity_ins__ProductName__c: "Pago arrendamiento"
            },
            {
                Id: "0QLdq0000006dmpGAA",
                vlocity_ins__ProductName__c: "Pago Administración"
            }
        ],
        FirstName: "Vale",
        DocumentType: "C",
        Phone: "3112456789",
        DocumentNumber: "1010876543",
        LastName: "Test",
        PropertyAddress: "Casita",
        RealEstateLicensePlate: "JAS-1234",
        PropertyCity: "Medellin",
        ContractStartDate: "29/01/2025",
        TimeDiff: 0,
        Id: "0Q0dq0000008iBxCAI",
        CreatedDate: "2025-01-23T15:27:40.000Z",
        vlocity_ins__EffectiveDate__c: "2025-01-23",
        vlocity_ins__TotalAmount__c: 194366,
        OpportunityId: "006dq000003b5DVAAY",
        SURAEstadoProcesoDePago__c: "Pending",
        RecordTypeId: "012D5000000BNyvIAG",
        planName: "Plan Esencial",
        quoteId: "0Q0dq0000008iBxCAI",
        leadId: "00Qdq000003HzTaEAK"
    },
    error: false
}



export const happypathmock2error = {
    data: {
        quoteId: "",
        message: "La cotización no existe 1"
    },
    error: true
}

export const elpropietariotienepolizaasactivas = {
    data: {
        quoteId: "0Q0dq0000008CK9CAM",
        message: "El propietario ya tiene pólizas activas",
    },
    error: true
}



























